import { capitalize } from '@gonfalon/strings/capitalize';
import { type IconProps, Icon } from '@launchpad-ui/icons';
import cx from 'clsx';

import { iconNameByMode } from '../constants';
import type { AiConfigMode } from '../types';

import styles from './AiModeIcon.module.css';

// Add hideIcon prop type
type HideIconProps = { hideIcon?: boolean };

// Accept hideIcon in AiModeIcon but ignore it (pass through to parent)
export function AiModeIcon({
  mode,
  hideIcon, // Swallow the prop (in case it's bubbled down)
  ...props
}: { mode: AiConfigMode } & IconProps & HideIconProps) {
  return <Icon name={iconNameByMode[mode]} {...props} />;
}

// Add hideIcon to AiModeTag
export function AiModeTag({ mode, hideIcon, ...props }: { mode: AiConfigMode } & IconProps & HideIconProps) {
  return (
    <>
      {!hideIcon && <AiModeIcon mode={mode} {...props} />}
      {capitalize(mode)}
    </>
  );
}

// Add hideIcon to AiModeChip
export function AiModeChip({
  mode,
  className,
  hideIcon,
  ...props
}: { mode: AiConfigMode; className?: string } & IconProps & HideIconProps) {
  const size = props.size ?? 'medium';
  return (
    <span className={cx(styles.chip, styles[size], className)}>
      <AiModeTag mode={mode} hideIcon={hideIcon} {...props} />
    </span>
  );
}
